import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_monitor_indoor_air_quality_line_legal'

export const dataPointDefinition = {
  retracedId: 'does_facility_monitor_indoor_air_quality_line_legal',
  name: 'Does the facility monitor indoor air quality in line with legal requirements?',
  description:
    "Indoor Air Quality' generally refers to comfort parameters such as temperature, humidity, and carbon dioxide as well as general concentrations of particulates or chemicals (VOC) in the general workspace. ",
  meta: {
    slcpMeta: {
      key: 'hs-gen-4',
      number: 'HS-GEN-9',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-gen-4', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31270,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
